<script lang="ts" setup>
definePage({
  meta: {
    layout: 'blank'
  }
})
</script>
<template>
  <div>
    <p>Oops, You are lost !</p>
    <RouterLink tag="p" to="/">Go back home</RouterLink>
  </div>
</template>
